
    <div class="work-packages-page--ui-view" wp-isolated-query-space>
      <ui-view></ui-view>
    </div>
  